import AuthGuard from '@/guard/auth'
import Navbar from '@/components/menu/Navbar'
import IamGuard from '@/guard/iam'
import AppsItemPage from '@/components/pages/AppsItemPage'

function Apps() {
	return (
		<AuthGuard>
			<IamGuard page='admin'>
				<div className='relative min-h-screen flex flex-col'>
					<Navbar></Navbar>
					<AppsItemPage></AppsItemPage>
				</div>
			</IamGuard>
		</AuthGuard>
	)
}

export default Apps
